import { Content } from './style'

export function Logo() {
    return <Content />
}
